// extracted by mini-css-extract-plugin
module.exports = {"rewards":"Rewards_rewards__Hk_kB"};